import { format, parseISO, startOfDay } from "date-fns";

const API_DATE_FORMAT = "yyyy-MM-dd";

// BE exchanges date-only values as ISO strings ("yyyy-MM-dd"); these helpers
// keep the string<->Date conversion (and the midnight normalization) in one place.
export const parseApiDate = (value: string): Date =>
	startOfDay(parseISO(value));

export const formatApiDate = (date: Date): string =>
	format(startOfDay(date), API_DATE_FORMAT);
